<template>
  <div id="teacher" class="main">
    <!-- teacher -->
    <div class="row">
      <div class="banner_order pc">
        <div class="teacher">
          <div class="train_person row">
            <div class="le col-lg-3 col-md-3 col-sm-3">
              <div class="le_z">
                <div class="thumbs row img-circle">
                  <img :src="teacher.thumbs?getSrc(teacher.thumbs):'../../static/images/def.jpg'" class="img-circle" width="100%"/>
                </div>
              </div>
            </div>
            <div class="ri col-lg-9 col-md-9 col-sm-9">
              <div class="row">
                <h1>{{teacher.name}}</h1>
              </div>
              <div class="row">
                <span>{{teacher.company}}</span>
                <span>{{teacher.position}}</span>
              </div>
              <div class="row">
                <p v-html="teacher.desc"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner_wap_order mob">
        <div class="wap_teacher">
          <div class="wap_train_person row">
            <div class="le">
              <div class="wap_img">
                <img :src="teacher.thumbs?getSrc(teacher.thumbs):'../../static/images/def.jpg'" width="100%"  class="img-circle"/>
              </div>
              </div>
              <div class="ri">
                <div class="row">
                  <h3>{{teacher.name}}&nbsp;&nbsp;</h3>
                </div>
                <div class="row">
                  <h5>{{teacher.company}}<br>{{teacher.position}}</h5>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- course -->
    <div class="paike_all row">
      <div class="teacher_jie mob">
        <p v-html="teacher.desc"></p>
      </div>
      <div class="paike">
        <div class="menu row">
          <a class="active" @click="setClass($event)">即将开始的MPD课程</a>
          <a @click="setClass($event)" v-if="teacher.publicCourse && teacher.publicCourse.length>0">MSUP公开课</a>
        </div>
        <div class="cont">
          <li class="showc">
            <div class="kec_all about_course" id="about_course">
              <div class="kec" v-for="(item,index) in teacher.thisCourse" :key="'tcourse'+index">
                <a @click.prevent="$router.push({path:'/course',name:'Course',query:{sid:params.sid, id:item.courseid}})">
                  <h1>{{item.title}}</h1>
                  <div class="row">
                    <!-- item.tag不统一以item.venueName代替 -->
                    <!-- <img v-if="item.venueName == '产品创新/体验设计' || item.venueName == '运营增长/体验设计'" src="../../static/images/teacher/title_01.png" class="zt"/> -->
                    <!-- <img v-if="item.venueName == '研发管理/团队效能'" src="../../static/images/teacher/title_05.png" class="zt"/> -->
                    <!-- <img v-if="item.venueName == '架构设计/技术战略'" src="../../static/images/teacher/title_02.png" class="zt"/> -->
                    <!-- <img v-if="item.venueName == '人工智能/数据科学' || item.venueName == '数据科学/人工智能'" src="../../static/images/teacher/title_03.png" class="zt"/> -->
                    <!-- <img v-if="item.venueName == '测试管理/运维发布'" src="../../static/images/teacher/title_03.png" class="zt"/> -->
                    <img v-if="item.venueName.includes('产品') || item.venueName.includes('运营')" src="../../static/images/teacher/title_01.png" class="zt"/>
                    <img v-if="item.venueName.includes('团队')" src="../../static/images/teacher/title_05.png" class="zt"/>
                    <img v-if="item.venueName.includes('架构')" src="../../static/images/teacher/title_02.png" class="zt"/>
                    <img v-if="item.venueName.includes('人工智能') || item.venueName.includes('数据')" src="../../static/images/teacher/title_04.png" class="zt"/>
                    <img v-if="item.venueName.includes('测试') || item.venueName.includes('运维')" src="../../static/images/teacher/title_03.png" class="zt"/>
                    <h2 v-html="item.venueName+'&nbsp;&nbsp;专场'"></h2>
                  </div>
                  <div class="time">
                    <img src="../../static/images/banner_img01.png"/>
                    <span>
                      {{getDate(item.date)}}&nbsp;&nbsp;
                      {{item.startTime}}--{{item.endTime}}
                    </span>
                  </div>
                  <p v-html="item.desc"></p>
                </a>
              </div>
            </div>
          </li>
          <li v-if="teacher.publicCourse && teacher.publicCourse.length>0">
            <div class="kec_all" id="msup_course">
              <div class="kec" v-for="(item,index) in teacher.publicCourse" :key="'tpcourse'+index">
                <!-- <a @click.prevent="$router.push({path:'/course',name:'Course',query:{sid:params.sid, id:item.courseid}})"> -->
                  <h1>{{item.title}}</h1>
                  <div class="row">
                    <slot v-if="item.tag == 1">
                      <img src="../../static/images/teacher/title_04.png"  class="zt"/>
                      <h2>工程实践/前沿趋势&nbsp;&nbsp;专场</h2>
                    </slot>
                    <slot v-if="item.tag == 2">
                      <img src="../../static/images/teacher/title_01.png"  class="zt"/>
                      <h2>产品创新/体验设计&nbsp;&nbsp;专场</h2>
                    </slot>
                    <slot v-if="item.tag == 3">
                      <img src="../../static/images/teacher/title_02.png"  class="zt"/>
                      <h2>架构设计/技术战略&nbsp;&nbsp;专场</h2>
                    </slot>
                    <slot v-if="item.tag == 4">
                      <img src="../../static/images/teacher/title_03.png"  class="zt"/>
                      <h2>测试管理/运维发布&nbsp;&nbsp;专场</h2>
                    </slot>
                    <slot v-if="item.tag == 5">
                      <img src="../../static/images/teacher/title_05.png"  class="zt"/>
                      <h2>团队管理/工程文化&nbsp;&nbsp;专场</h2>
                    </slot>
                  </div>
                  <p v-html="item.desc"></p>
                <!-- </a> -->
              </div>
            </div>
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-redeclare */
import $ from 'jquery'

export default {
  name: 'Teacher',
  data () {
    return {
      params: '',
      teacher: []
    }
  },
  methods: {
    getSrc: function (img) {
      return img.split('?')[0] + '?imageView2/1/w/500/h/500/q/100'
      // return img.split('?')[0]+'?imageMogr2/auto-orient/thumbnail/200x/gravity/North/crop/200x200/blur/1x0/quality/100';
    },
    setClass: function (e) {
      $(e.srcElement).addClass('active')
      $(e.srcElement).siblings().removeClass('active')
      var index = $(e.srcElement).index()
      var $li = $('.paike .cont li').eq(index)
      $li.addClass('showc')
      $li.siblings().removeClass('showc')
    },
    setSize: function () {
      var xian = $('.train_person .thumbs img')
      var realWidth = xian.width()
      var realHeight = realWidth
      $('.train_person .thumbs  img').css({ height: realHeight })
      var xianf = $('.wap_train_person .wap_img')
      var realWidth = xianf.width()
      var realHeight = realWidth
      $('.wap_train_person .wap_img img').css({ height: realHeight })
    },
    getDate: function (d) {
      return this.global.formatTime(d, 'Y.M.D')
    },
    getTeacher: function () {
      var area_id = this.global.area_id
      if (this.params.sid) {
        area_id = this.params.sid
      }
      var _this = this
      var teacher_id = this.params.id
      var url_teacher = this.global.url.teacher_detail + area_id + '/' + teacher_id
      this.setSize()
      window.onresize = function () {
        _this.setSize()
      }
      this.$http
        .jsonp(url_teacher)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log(data);
          this.teacher = []
          if (data.errno && data.errno.toString() === '0') {
            document.title =
              '' +
              data.data.name +
              '、' +
              data.data.company +
              '、' +
              data.data.position +
              '—MPD工作坊专家客座教练'
            this.teacher = data.data
            // console.log(this.teacher);
          }
        })
    }
  },
  created () {
    this.params = this.$route.query
    // console.log(this.params);
    this.getTeacher()
  },
  watch: {
    $route (to, from) {
      // 监听路由是否变化
      if (to.query.id.toString() !== from.query.id.toString()) {
        this.params = this.$route.query
        this.getCourseId()
      }
    }
  }
}
</script>

<style scoped>
/*  */
</style>



// WEBPACK FOOTER //
// src/views/Teacher.vue